(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var selectors = [
    ['.approved-hero__inner', 'gk-reveal gk-reveal--soft', 0],
    ['.approved-hero__media', 'gk-reveal gk-reveal--image', 90],
    ['.featured-products__heading', 'gk-reveal gk-reveal--soft', 0],
    ['.featured-products .product-card', 'gk-reveal', 100],
    ['.fall-story__head', 'gk-reveal gk-reveal--soft', 0],
    ['.fall-story__card', 'gk-reveal gk-reveal--image', 110],
    ['.approved-collections__title-wrap', 'gk-reveal gk-reveal--soft', 0],
    ['.approved-collection-card', 'gk-reveal gk-reveal--image', 90],
    ['.archive-signup__archive', 'gk-reveal gk-reveal--soft', 0],
    ['.archive-signup__newsletter', 'gk-reveal gk-reveal--soft', 110]
  ];
  var observer;

  function mark(root) {
    selectors.forEach(function (rule) {
      var nodes = (root || document).querySelectorAll(rule[0]);
      nodes.forEach(function (node, index) {
        if (node.dataset.gkRevealBound) return;
        node.dataset.gkRevealBound = 'true';
        rule[1].split(' ').forEach(function (c) { node.classList.add(c); });
        node.style.setProperty('--gk-reveal-delay', (index * rule[2]) + 'ms');
        if (reduceMotion || Shopify.designMode) {
          node.classList.add('is-visible');
        } else if (observer) {
          observer.observe(node);
        }
      });
    });
  }

  function init() {
    if (!reduceMotion && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    mark(document);
    document.documentElement.classList.add('gk-reveal-ready');
    requestAnimationFrame(function () {
      document.querySelectorAll('.gk-reveal').forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.top < window.innerHeight * .94) node.classList.add('is-visible');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) { mark(event.target); });
})();
